import { QUOTE_SETTINGS } from 'app/pages/repairOrders/components/RepairOrderListing';
import React from 'react';
import styled from 'styled-components/macro';

const Number = styled.div`
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
`;

type Props = {
  quoteSettings: string;
  closeRatioItems: number;
  closeRatioDollars: number;
};
export const CloseRatio = ({
  quoteSettings,
  closeRatioItems,
  closeRatioDollars,
}: Props) => {
  const closeRatio =
    !quoteSettings || quoteSettings === QUOTE_SETTINGS.DOLLAR
      ? closeRatioDollars
      : closeRatioItems;
  return <Number>{closeRatio}%</Number>;
};
